import { render, staticRenderFns } from "./FileData.vue?vue&type=template&id=7a135342"
import script from "./FileData.vue?vue&type=script&lang=js"
export * from "./FileData.vue?vue&type=script&lang=js"
import style0 from "./FileData.vue?vue&type=style&index=0&id=7a135342&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports